import { cardiacBeatTime, cardiacCycles } from '../monitors/pulseModel.js';

export const createGrid = ({ cols, rows, previous = [], random = Math.random }) =>
  Array.from({ length: cols }, (_, col) =>
    Array.from({ length: rows }, (value, row) => previous[col]?.[row] ?? Number(random() > 0.85)),
  );

export const nextGeneration = (grid) => {
  const cols = grid.length;
  const rows = grid[0]?.length || 0;
  return grid.map((column, col) =>
    column.map((cell, row) => {
      let neighbors = 0;
      for (let x = Math.max(0, col - 1); x <= Math.min(cols - 1, col + 1); x += 1) {
        for (let y = Math.max(0, row - 1); y <= Math.min(rows - 1, row + 1); y += 1) {
          if (x !== col || y !== row) neighbors += grid[x][y];
        }
      }
      return Number(neighbors === 3 || (cell === 1 && neighbors === 2));
    }),
  );
};

export const heartbeatFrame = (seconds) => {
  // Account for rounding when inverting the clock at an exact R-wave time.
  const beat = Math.floor(cardiacCycles(seconds) + 1e-9);
  const age = Math.max(0, seconds - cardiacBeatTime(beat));
  return { beat, pulse: Math.exp(-age / 0.16) };
};

export class HeartbeatLife {
  constructor({ grid, seconds }) {
    this.grid = grid;
    this.lastBeat = heartbeatFrame(seconds).beat;
    this.generation = 0;
  }

  update(seconds) {
    const { beat, pulse } = heartbeatFrame(seconds);
    if (beat > this.lastBeat) {
      this.grid = nextGeneration(this.grid);
      this.generation += 1;
      // After a suspended tab, resume at the current beat without a burst of
      // historical generations. Ordinary animation frames advance once per R.
      this.lastBeat = beat;
    }
    return pulse;
  }

  resync(seconds) {
    this.lastBeat = heartbeatFrame(seconds).beat;
  }

  resize(cols, rows) {
    this.grid = createGrid({ cols, rows, previous: this.grid });
  }
}
